if (!customElements.get("custom-product-as-variant")) {
  class CustomProductAsVariant extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.onVariantClick.bind(this));
    }

    onVariantClick(event) {
      event.preventDefault();

      // Since event.preventDefault() blocks the native label→radio association,
      // manually sync the radio checked state for color-swatch mode.
      const radioInput = this.querySelector('input[type="radio"]');
      if (radioInput && !radioInput.checked) {
        const groupName = radioInput.name;
        document
          .querySelectorAll(`input[name="${CSS.escape(groupName)}"]`)
          .forEach(r => (r.checked = false));
        radioInput.checked = true;
      }

      const isProductPage     = document.querySelector("safe-sticky.product-info");
      const isProductQuickBuy = document.querySelector("quick-buy-modal safe-sticky.product-info");

      if (isProductQuickBuy) {
        window.location.href = this.dataset.variantUrl;
        return;
      }

      // =========================
      // PRODUCT PAGE
      // =========================
      if (isProductPage) {
        const main = document.querySelector("#main");

        // ─────────────────────────────────────────────────────────────────────
        // WHY WE DON'T FADE #main:
        //   The site uses a black default color scheme (scheme-3: #000000).
        //   Fading #main to opacity:0 makes it transparent, revealing the black
        //   body behind it — causing the black flash the user sees.
        //
        // SOLUTION:
        //   Fade only the INNER sections (product info + gallery) which carry
        //   their own white background.  #main itself stays fully opaque at
        //   all times, so the black body is never exposed.
        //
        //   After the full #main swap (original logic preserved), re-query the
        //   new inner elements and set them to opacity:0 synchronously (before
        //   the browser paints), then fade back to opacity:1.
        // ─────────────────────────────────────────────────────────────────────

        // Selectors for inner sections to transition
        const gallerySelectors = [
          ".product-gallery",
          ".product__gallery",
          ".product-gallery-list",
          ".product-page__gallery",
          ".product__media",
          ".media-gallery",
          "[class*='product-gallery']",
        ];

        const productInfoEl = document.querySelector("safe-sticky.product-info");

        let galleryEl = null;
        for (const sel of gallerySelectors) {
          galleryEl = document.querySelector(sel);
          if (galleryEl) break;
        }

        // ── Step 1: fade out INNER sections (not #main) ──────────────────────
        const fadeOut = (el) => {
          if (!el) return;
          el.style.transition    = "opacity 0.15s ease-out";
          el.style.opacity       = "0";
          el.style.pointerEvents = "none";
        };
        fadeOut(productInfoEl);
        fadeOut(galleryEl);

        // ── Step 2: fetch + wait for fade (in parallel) ───────────────────────
        const fetchDone = fetch(this.dataset.variantUrl).then(r => r.text());
        const fadeDone  = new Promise(resolve => setTimeout(resolve, 160));

        // ── Step 3: swap #main while inner sections are invisible ─────────────
        Promise.all([fetchDone, fadeDone])
          .then(([htmlText]) => {
            const html    = new DOMParser().parseFromString(htmlText, "text/html");
            const newMain = html.querySelector("#main");

            if (main && newMain) {
              main.innerHTML = newMain.innerHTML;   // ← original logic preserved
            }

            // ✅ IMPORTANT: update URL
            window.history.pushState({}, "", this.dataset.variantUrl);

            // Re-query new elements (old references were destroyed by innerHTML swap)
            const newProductInfoEl = document.querySelector("safe-sticky.product-info");
            let newGalleryEl = null;
            for (const sel of gallerySelectors) {
              newGalleryEl = document.querySelector(sel);
              if (newGalleryEl) break;
            }

            // Set new elements to opacity:0 synchronously, BEFORE the browser
            // paints — so they never flash at opacity:1 after the swap.
            const newTargets = [newProductInfoEl, newGalleryEl].filter(Boolean);
            newTargets.forEach(el => {
              el.style.transition    = "none";
              el.style.opacity       = "0";
              el.style.pointerEvents = "none";
            });

            // ── Step 4: fade back in ────────────────────────────────────────
            // Double rAF ensures the browser has committed the opacity:0 paint
            // before we start the transition, so fade-in is actually visible.
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                newTargets.forEach(el => {
                  el.style.transition    = "opacity 0.2s ease-in";
                  el.style.opacity       = "1";
                  el.style.pointerEvents = "";
                });
                // Clean up inline styles after transition completes
                setTimeout(() => {
                  newTargets.forEach(el => {
                    el.style.transition = "";
                  });
                }, 250);
              });
            });
          })
          .catch(() => {
            // On network error: hard-navigate as fallback
            window.location.href = this.dataset.variantUrl;
          });

        return;
      }

      // =========================
      // COLLECTION PAGE (NO FETCH)
      // =========================
      const productCard = this.closest(".product-card");
      if (!productCard) return;

      const link          = productCard.querySelector(".product-card__figure a");
      const titleEl       = productCard.querySelector(".product-title");
      const primaryImg    = productCard.querySelector(".product-card__image--primary");
      const secondaryImg  = productCard.querySelector(".product-card__image--secondary");
      const quickBuyModal = productCard.querySelector("quick-buy-modal");

      // PRIMARY IMAGE
      if (primaryImg && this.dataset.image) {
        primaryImg.src = this.dataset.image;
        primaryImg.removeAttribute("srcset");
        if (this.dataset.alt) primaryImg.alt = this.dataset.alt;
      }

      // SECONDARY IMAGE
      if (secondaryImg && this.dataset.secondaryImage) {
        secondaryImg.src = this.dataset.secondaryImage;
        secondaryImg.removeAttribute("srcset");
        if (this.dataset.secondaryAlt) secondaryImg.alt = this.dataset.secondaryAlt;
      }

      // QUICK-BUY HANDLE
      if (quickBuyModal) {
        const baseHandle = this.dataset.variantUrl.replace("/products/", "");
        quickBuyModal.setAttribute("handle", baseHandle);
      }

      // UPDATE LINK
      if (link) link.href = this.dataset.variantUrl;

      // UPDATE TITLE
      if (titleEl) {
        titleEl.textContent = this.dataset.title;
        titleEl.href        = this.dataset.variantUrl;
      }

      // ACTIVE STATE (thumbnail-swatch / image mode)
      productCard
        .querySelectorAll(".thumbnail-swatch")
        .forEach(el => el.classList.remove("active"));

      this.classList.add("active");
    }
  }

  customElements.define("custom-product-as-variant", CustomProductAsVariant);
}